import React from 'react';
import Icon from '../common/Icon/Icon';
import styles from './TipsCard.module.css';

interface TipsCardProps {
  title: string;
  subtitle?: string;
  items: readonly string[];
  variant: 'avoid' | 'howTo';
}

const TipsCard: React.FC<TipsCardProps> = ({ title, subtitle, items, variant }) => (
  <article className={styles.card}>
    <h4 className={styles.title}>{title}</h4>
    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}

    {items.map((item) => (
      <div key={item} className={styles.tipRow}>
        <Icon
          name={variant === 'avoid' ? 'close' : 'check'}
          size={24}
          className={variant === 'avoid' ? styles.avoidIcon : styles.howToIcon}
        />
        <p className={styles.tipItem}>{item}</p>
      </div>
    ))}
  </article>
);

export default TipsCard;
